import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container-fluid" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

import { TipoMensagem } from '@/consts/consts';
import mensagem from '@/hooks/mensagem';
// import Perfil from '@/model/Perfil';
// import Usuario from '@/model/Usuario';
// import services from '@/services';
// import { store } from '@/store';
import { reactive, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Principal',
  props: ['maiusculo', 'retornaPossuiPermissao', 'retornaDataBR', 'retornaIdVDatePicker', 'retornaDataUSA'],
  setup(__props) {

const props = __props;

// import ModalDorape from '@/components/ModalDorape.vue';
const showCalendar = ref(false);

const handleDayClick = (day: any) => {
  console.log("Dia selecionado:", day);
  showCalendar.value = false; // fecha o calendário após um dia ser clicado
};



const state = reactive({
  pMostrarModal: Boolean(),
  pMostrarSegundaModal: Boolean(),

  username: String(),
  funcao: String(),
});

function ativarModal() {
  state.pMostrarModal = true;
}

function ativarSegundaModal() {
  state.pMostrarSegundaModal = true;
}

function modal(result: string, id: string, dados: object) {
  if (id == "frmCadastro") {
    state.pMostrarModal = false;
  } else {
    state.pMostrarSegundaModal = false;
  }
}

function setMensagem() {
  const msg = mensagem();
  msg.InserirMensagem('teste', 'teste', TipoMensagem.Alert);

  // msg.InserirMensagem(new Date().getTime().toString() + 2, 'teste 2','teste 2',TipoMensagem.Error);   
  // msg.InserirMensagem(new Date().getTime().toString() + 3, 'teste 3','teste 3',TipoMensagem.Alert);   
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})